import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mcrit-time-table-week-header',
  templateUrl: './week-time-table-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./week-time-table-header.component.scss']
})
export class WeekTimeTableHeaderComponent implements OnInit {
  @Input() year: number;
  @Input() weekNumber: number;

  @Output() change = new EventEmitter();

  public changeData(type: string, value: number): void {
    this.change.emit({type: type, value: value});
  }

  constructor() { }

  ngOnInit() {
  }

}
